import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom'
import { fetchSocialAccountThunk } from 'slices/socialAccounts/thunk';
import { AppDispatch, RootState } from 'store';
import PerfectScrollbar from 'react-perfect-scrollbar'
import AccountDetails from 'Components/social-account/AccountDetails';
import { isEmpty } from 'lodash';
import AudienceDetails from 'Components/campaigns/applications/AudienceDetails';
import { SocialAccountInsights } from 'types/influencer';
import { ACCOUNT_NOT_FOUND_MSG } from 'constants/global';
import { Container } from 'reactstrap';
import InfluencerCardHeader from 'Components/influencer/InfluencerCardHeader';
import SocialAccountHeader from 'Components/social-account/SocialAccountHeader';
import InfluencerContent from 'Components/influencer/InfluencerContent';
import { SocialPost } from 'types/campaign/collaborations';
import { closeSocialPostModal, showSocialPostModal } from 'slices/ui/reducer';
import SocialPostModal from 'Components/social-account/SocialPostModal';
import ifConfigured from 'hoc/ifConfigured';
import Loader from 'Components/Common/Loader';

const SocialAccount = () => {

    const { socialAccountId } = useParams();
    const socialAccountData = useSelector((state: RootState) => state.socialAccountState.items[socialAccountId!]);
    const loading = useSelector((state: RootState) => state.socialAccountState.loading)
    const socialAccount = socialAccountData?.account ?? null;
    const nicheList = useSelector((state: RootState) => state.auth.master?.niche_list ?? {});

    const socialPostModal = useSelector((state: RootState) => state.ui.socialPostModal);

    const dispatch: AppDispatch = useDispatch();

    useEffect(() => {
        if (!socialAccountId) return;
        dispatch(fetchSocialAccountThunk({ socialAccountId }))
    }, [socialAccountId])

    const getAudienceDetails = useCallback(() => {
        if (!socialAccount?.ig?.insights) return {};

        let audienceDetails: SocialAccountInsights = {};

        if (socialAccount?.ig?.insights?.demographic && !isEmpty(socialAccount.ig?.insights?.demographic)) {
            audienceDetails = { ...socialAccount.ig?.insights?.demographic };
        }

        if (socialAccount?.ig?.insights?.niche_likes && !isEmpty(socialAccount.ig?.insights?.niche_likes)) {
            const niche_likes: Record<string, any> = {};
            for (let key in socialAccount.ig.insights.niche_likes) {
                const nicheName = nicheList[key];
                if (nicheName) {
                    niche_likes[nicheName] = socialAccount.ig.insights.niche_likes[key];
                }
            }
            audienceDetails = { ...audienceDetails, niche_likes };
        }

        return audienceDetails;
    }, [socialAccount]);

    const handleMediaClick = (post: SocialPost) => {
        dispatch(showSocialPostModal({ postId: post.uuid, socialAccount }))
    }


    if (loading) return <Loader />



    return (
        <>
            <div className="">
                <Container fluid className='p-3'>
                    <div className="card p-3">
                        <div className="card-body p-3">
                            <div className="d-flex w-100 gap-3">
                                <div className="info w-50">
                                    {
                                        (socialAccount) ? (
                                            <div className="section-1 social-account-container position-relative">
                                                <PerfectScrollbar>
                                                    <div>
                                                        <div>
                                                            <AccountDetails socialAccount={socialAccount} />
                                                        </div>
                                                        {
                                                            (socialAccount?.ig?.insights?.demographic && !isEmpty(socialAccount.ig?.insights?.demographic) || (socialAccount?.ig?.insights?.niche_likes || !isEmpty(socialAccount?.ig?.insights?.niche_likes))) &&
                                                            <div className="mt-3">
                                                                <AudienceDetails socialAccountInsights={getAudienceDetails()} />
                                                            </div>
                                                        }
                                                    </div>
                                                </PerfectScrollbar>
                                            </div>
                                        ) : (
                                            <div className="account-not-available-card h-100">
                                                <span className="w-75">{ACCOUNT_NOT_FOUND_MSG}</span>
                                            </div>
                                        )
                                    }
                                </div>
                                <div className="influencer-content w-50">
                                    <div className="section-1 social-account-container position-relative">
                                        <PerfectScrollbar id='scrollableDiv'>
                                            <div className="card mb-1">
                                                <div className="border-bottom-1">
                                                    <div className="p-4">
                                                        <SocialAccountHeader borderBottom={false} socialAccount={socialAccount} hideAdditionalInfo={true} />
                                                    </div>
                                                </div>
                                                {
                                                    socialAccount ? (
                                                        <InfluencerContent sort='timestamp_tz' hideRelevantTab onMediaClick={handleMediaClick} socialAccountId={socialAccount.uuid} socialAccount={socialAccount} />
                                                    ) : (
                                                        <div className="account-not-available-card influncer-profile-content">
                                                            <span className="w-75">{ACCOUNT_NOT_FOUND_MSG}</span>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        </PerfectScrollbar>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container >
            </div>
            <SocialPostModal
                isOpen={!!socialPostModal}
                onClose={() => dispatch(closeSocialPostModal())}
                socialAccount={socialPostModal?.socialAccount}
                postId={socialPostModal?.postId}
            />
        </>
    )
}

export default ifConfigured(SocialAccount, 'agency_social_connect')
